export default function isNotNullOrEmpty(obj) {
  return typeof obj !== "undefined" && obj !== null && Object.keys(obj).length > 0
}
